module.exports = __webpack_public_path__ + "img/user.0043894f.svg";